import React from 'react';
import {ViewProps} from './model';
import {GetMobileTableStyles} from './styles';
import {View} from 'react-native';
import {Text} from '../../../../../shared/components/text';
import {format} from 'date-fns';
import {dateFormats} from '../../../../../shared/constants/date';
//TODO Change name and check internals of molodayaArticaResponsePayload
import {WithdrawSource} from '../../../../../shared/models/api/molodayaArticaResponsePayload';
import {numToPostfix} from '../../../../../shared/utils/text';
import {Link} from '../../../../../shared/components/link';

export const MobileView = ({data}: ViewProps) => {
  const styles = GetMobileTableStyles();
  return (
    <View style={styles.container}>
      {!data?.length ? (
        <View>
          <Text style={styles.noData}>Нет данных</Text>
          <Link
            textStyle={styles.link}
            external
            href='https://xn----7sbbaq1anbcjwb4a3a4q.xn--p1ai/profile/points'
            testID='go-to-profile-points'>
            Подключить учетную запись ЕКЖ в Молодой Арктике
          </Link>
        </View>
      ) : (
        data.map((item) => (
          <View key={item.date} style={styles.item}>
            <Text style={styles.itemHead} type='body'>
              {item.withdrawSource === WithdrawSource.Arctica
                ? item.products.map((p) => `${p.title} x${p.count}`)
                : 'Обмен баллов'}
            </Text>
            <View style={styles.itemBody}>
              <Text type='action'>
                {item.score > 0 ? `${item.score} ${numToPostfix(item.score, ['балл', 'балла', 'баллов'])}` : ''}
              </Text>
              <Text type='bodySmallLight' style={styles.itemBodyDate}>
                {format(new Date(item.date), dateFormats.fullDate)}
              </Text>
            </View>
          </View>
        ))
      )}
    </View>
  );
};
